<script setup lang="ts">
import { useScreen } from "@/composable/useResponsive";

defineProps<{
  title: string;
  description?: string;
}>();

const { screen } = useScreen();
</script>

<template>
  <div class="organization-page-layout h-100 d-flex flex-column">
    <div class="page-header px-4 pt-4 pb-3">
      <div
        class="d-flex gap-3"
        :class="
          screen.lt.md
            ? 'flex-column'
            : 'justify-content-between align-items-start'
        "
      >
        <div class="flex-grow-1">
          <h1 class="page-title mb-1">{{ title }}</h1>
          <p v-if="description" class="page-description text-muted mb-0">
            {{ description }}
          </p>
        </div>
        <div v-if="$slots.actions" class="d-flex gap-2 flex-shrink-0 flex-wrap">
          <slot name="actions" />
        </div>
      </div>
    </div>

    <div
      v-if="$slots.toolbar"
      class="page-toolbar px-4 py-2 border-bottom d-flex align-items-center gap-2"
    >
      <slot name="toolbar" />
    </div>

    <div class="page-content flex-grow-1 overflow-auto px-4 py-3">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.organization-page-layout {
  background-color: var(--bs-body-bg);
}

.page-header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--bs-border-color);
}

.page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--bs-body-color);
}

.page-description {
  font-size: 0.875rem;
}

.page-toolbar {
  flex-shrink: 0;
  background-color: var(--bs-body-bg);
}

.page-content {
  background-color: var(--bs-body-bg);
}
</style>
